import BaseInput from 'app/components/forms/base_input/component'
import {
  firstElementOrEmptyString,
  withValidation,
} from 'app/components/forms/util'
import { validateEmailAddresses } from 'app/shared_components/validations'

export const validateCommaSeparatedEmails = (value: string) =>
  firstElementOrEmptyString(
    validateEmailAddresses(
      value,
      'Invalid emails, comma separated emails required.',
    ),
  )

const InputCommaSeparatedEmails = withValidation(
  BaseInput,
  validateCommaSeparatedEmails,
)

export default InputCommaSeparatedEmails
